import React from 'react';
import Button from 'devextreme-react/button';

import { AppFooter } from '../..';
import { useOpenPages } from '../../../contexts/open-pages';

import './SideNavigationMenu.scss';

export const SideNavigationMenu = () => {
  const { pages, activeKey, activatePage, closePage } = useOpenPages();

  return (
    <div className='dx-swatch-additional side-navigation-menu'>
      <div className='menu-container theme-dependent'>
        <div className='open-pages-heading'>
          <span>Trang đang mở</span>
          <span className='open-pages-count'>{pages.length}</span>
        </div>
        {pages.length ? (
          <div className='open-pages-list' role='list' aria-label='Các trang đang mở'>
            {pages.map(page => (
              <div className={`open-page-item${page.key === activeKey ? ' active' : ''}`} key={page.key} role='listitem'>
                <button
                  className='open-page-select'
                  type='button'
                  title={page.title}
                  aria-current={page.key === activeKey ? 'page' : undefined}
                  onClick={() => activatePage(page)}
                >
                  <span className='dx-icon dx-icon-file' aria-hidden='true' />
                  <span className='open-page-title'>{page.title}</span>
                </button>
                <Button
                  className='open-page-close'
                  icon='close'
                  stylingMode='text'
                  hint={`Đóng ${page.title}`}
                  elementAttr={{ 'aria-label': `Đóng ${page.title}` }}
                  onClick={() => closePage(page)}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className='open-pages-empty'>Chưa có trang nào được mở.</div>
        )}
      </div>
      <AppFooter>© {new Date().getFullYear()} Vicem Bỉm Sơn</AppFooter>
    </div>
  );
};
